module.exports = {"name":"globalNavBackButton","audiences":["englishMembers"],"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"showBackButton":false},"autoTrack":true,"variations":[{"name":"turnedOn","weight":1,"values":{"showBackButton":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/globalNavBackButton.json
// module id = +Dab
// module chunks = 0